import React, { PureComponent, ReactNode } from "react";
import { Animated } from "react-animated-css";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../../../components/CustomNav/CustomNav.Component";

import {
  Container,
  MenuGrid,
  MenuGridItem,
} from "../../Teachers/TeacherMenu.styles";
import profileImg from "../../../assets/images/mainmenus/profile.png";
import learnersImg from "../../../assets/images/mainmenus/learners.png";
import { currentUser, isUserLoggedIn } from "src/common/services";
import {
  Content,
  PickerHeader,
} from "../../DataCenter/CourseDetails/CourseDetails.styles";
import {
  ContentRow,
  SearchItemsList,
  UserSearchItem,
} from "../../DataCenter/DataCentre.styles";
import withServices from "src/HOCs/withServices";
import Modal from "react-awesome-modal";
import { ModalContainer } from "src/pages/Onboard/Common/Common.styles";

interface Props {
  history: any;
  isDataCentre?: any;
  services?: any;
}
interface State {
  path: string;
  toLogin: boolean;
  searchString: string;
  searchUsers: [];
  generalStats: Record<string, any>;
  modalOpen: boolean;
}
const menuItems = [
  {
    title: "Explore Course Performance",
    description:
      "Have a look at your institutions overall course and lesson performance",
    color: "#ff7a03",
    bg: learnersImg,
    to: "/schools/datacentre",
  },
  {
    title: "Explore your Learners' Engagement",
    description: "Have a look your least active learners",
    color: "#c003ff",
    bg: learnersImg,
    to: "/schools/learner-activity",
  },
];

const Stats = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p.stat > span {
    color: var(--green);
    margin: 0.5rem;
  }
  /* p.no-stats {color: var(--red);} */
  i {
    display: block;
    font-size: 50px;
  }
  i.fa-ban {
    color: var(--red);
  }
  i.fa-check {
    color: var(--green);
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  width: 60%;
  align-items: center;
  justify-content: center;

  button.blue-button {
    margin-left: 2em;
    margin-top: 0.5em;
    height: 45px;
  }
`;

class DataCentreMenu extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      path: "",
      toLogin: false,
      searchString: "",
      searchUsers: [],
      generalStats: {},
      modalOpen: false,
    };

    this.onSearchChange = this.onSearchChange.bind(this);
    // this.clearSearch = this.clearSearch.bind(this);
  }

  public componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
      return;
    }
  }

  public onLogout = (arg) => {
    this.setState({ toLogin: true });
  };

  public onMenuItemClick = (path) => {
    if (path === "helpcenter") {
      window.open("https://myperformancelearning.com/help", "_blank");
      return;
    }
    this.props.history.push(path);
  };

  public async onSearchChange(e) {
    const searchString = e.target.value;
    if (!searchString.length || searchString === " ") {
      this.setState({ searchString: "", searchUsers: [] });
      return;
    }
    const {
      services: { institutionsAPI, currentUserID },
    } = this.props;
    const res = await institutionsAPI.userGlobalSearch(
      currentUserID,
      "students",
      searchString
    );
    this.setState({ searchUsers: res.data.users, searchString });
  }

  public async fetchLearnerGeneralStats(learnerId) {
    const res =
      await this.props.services.institutionsAPI.getLearnerGeneralStats(
        learnerId
      );
    console.log(res);
    if (res.status === 404) {
      this.setState({ generalStats: { available: false } });
    }
    if (res.status === 200) {
      this.setState({ generalStats: { available: true, ...res.data } });
    }

    this.setState({ modalOpen: true });
  }

  public toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  };

  // public clearSearch = () => {
  //   this.setState({ searchUsers: []});
  // };

  public renderStatsModal = () => {
    const { generalStats } = this.state;
    return (
      <Modal
        visible={this.state.modalOpen}
        effect="fadeInDown"
        onClickAway={this.toggleModal}
      >
        <ModalContainer height={200}>
          {generalStats.available ? (
            <Stats>
              <i className="fa fa-check" />
              <p> Here's a summary of this learner's engagement</p>
              {generalStats.last_completed_attempt ? (
                <>
                  <p className="stat">
                    Last attempt:{" "}
                    <span>
                      {new Date(
                        generalStats.last_completed_attempt.DateCompleted
                      ).toLocaleString()}
                    </span>
                  </p>
                  <p className="stat">
                    Last Attempt Completed? -{" "}
                    <span>
                      {" "}
                      {generalStats.last_completed_attempt.IsComplete
                        ? "Yes"
                        : "No"}
                    </span>
                  </p>
                  <p className="stat">
                    Total Pathways Completed -{" "}
                    <span> {generalStats.total_completed}</span>
                  </p>
                </>
              ) : (
                <p className="stat">
                  Attemps: <span>0</span>
                </p>
              )}
              <p className="stat">
                Last Login:{" "}
                <span>
                  {new Date(generalStats.last_login).toLocaleString()}
                </span>
              </p>
            </Stats>
          ) : (
            <Stats>
              <i className="fa fa-ban" />
              <p className="no-stats">
                Nothing to see yet! Has this learner started using Performance
                Learning?
              </p>
            </Stats>
          )}
        </ModalContainer>
      </Modal>
    );
  };

  public render(): ReactNode {
    const { searchUsers, searchString } = this.state;
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <Container>
        <Navbar logoutParent={this.onLogout} />
        <h1 className="menu-heading">
          Hey <span>{currentUser()}</span>
        </h1>

        <SearchItemsList>
          <PickerHeader>
            Take a look at a specific learner's engagement
          </PickerHeader>

          <Row>
            <input
              onChange={this.onSearchChange}
              type="text"
              className="custom-textfield"
              placeholder="Search"
            />
            {/* <button
              onClick={this.clearSearch}
              className="blue-button"
            >
              Clear
            </button> */}
          </Row>

          {!searchUsers.length && searchString.length ? (
            <p style={{ color: "var(--red)" }}>No Match</p>
          ) : (
            searchUsers.map((user: any) => (
              <UserSearchItem
                onClick={this.fetchLearnerGeneralStats.bind(this, user.id)}
                key={user.id}
              >
                <span>{user.User}</span>{" "}
                <button className="blue-button">Explore</button>
              </UserSearchItem>
            ))
          )}
        </SearchItemsList>

        <PickerHeader style={{ marginTop: "2em" }}>
          Or <br /> Explore your institutions overall course performance
        </PickerHeader>

        <MenuGrid style={{ marginTop: "1em" }}>
          {menuItems.map((item, i) => (
            <Animated
              animationIn="fadeIn"
              animationOut="fadeOut"
              isVisible={true}
              animationInDuration={2000}
              key={`school_menu_item_${i}`}
            >
              <MenuGridItem
                key={`school_menu_item_${i}`}
                highlightColor={item.color}
                backgroundImage={item.bg}
              >
                <div className="bg-holder" />

                <div className="menu-item-content">
                  <div>
                    <h2 className="menu-item-name">{item.title}</h2>
                    <p className="menu-item-description">{item.description}</p>
                  </div>
                  <button
                    onClick={this.onMenuItemClick.bind(this, item.to)}
                    className="menu-item-btn"
                  >
                    EXPLORE
                  </button>
                </div>
              </MenuGridItem>
            </Animated>
          ))}
        </MenuGrid>
        {this.renderStatsModal()}
      </Container>
    );
  }
}

export default withServices(DataCentreMenu);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/DataCentreMenu.tsx